import React from 'react';
import { Box } from '@mui/material';
import Hero from './components/Hero';
import AboutMe from './components/AboutMe';
import WorkHistory from './components/WorkHistory';
import DigitalArtwork from './components/DigitalArtwork';
import Contact from './components/Contact';

function App() {
  return (
    <Box>
      <Hero />
      <WorkHistory />
      <AboutMe />
      <DigitalArtwork />
      <Contact />
    </Box>
  );
}

export default App; 